





















import Vue, { PropType } from "vue";

export interface ProgressBarProps {
  waitingTime: number;
  isComplete: boolean;
}

export interface ProgressBarData {
  progressRate: number;
  setIntervalId: number;
}

export default Vue.extend({
  name: "vc-progress-bar",
  props: {
    isComplete: {
      type: Boolean as PropType<ProgressBarProps["isComplete"]>,
      default: false
    },
    waitingTime: {
      type: Number as PropType<ProgressBarProps["waitingTime"]>,
      default: 0
    }
  },
  data(): ProgressBarData {
    return {
      progressRate: 0,
      setIntervalId: 0
    };
  },
  mounted() {
    const intervalId = setInterval(() => {
      if (this.isComplete) {
        this.progressRate = 100;
        clearInterval(intervalId);
        return;
      }

      this.progressRate += Math.floor(100 / this.waitingTime);
      // 95% 超えたら 95% で固定
      this.progressRate = this.progressRate > 95 ? 95 : this.progressRate;
    }, 1000);
  },
  watch: {
    // isCompleteが true になったら即時 progressRate を 100 に変更
    isComplete() {
      if (this.isComplete) {
        this.progressRate = 100;
      }
    }
  }
});
